import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_COMMUNITIES: {
        url: "bestuur",
        method: "get",
    },

    GET_CONTRACTS: (
        communityId,
        pageSizeCount,
        pageNumber,
        anonymize,
        search
    ) => {
        const params = new URLSearchParams();

        params.append("iCommunityId", communityId);
        params.append("pageSize", pageSizeCount);
        params.append("page", pageNumber);
        params.append('search',search)

        if (
            anonymize !== null &&
            anonymize !== undefined
        ) {
            params.append("anonymize", anonymize);
        }

        return {
            url: `contracts?${params.toString()}`,
            method: "get",
        };
    },

    POST_SEARCH_BESTUUR: {
        url: "bestuur-search",
        method: "post",
    },

    POST_UPDATE_ANONYMIZE: {
        url: "contract/update",
        method: "post",
    },
};

export const useCommunities = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_COMMUNITIES);

export const useContracts = (communityId, pageSizeCount, pageNumber, anonymize,search) =>
    useApiFetcherSWR(API_ENDPOINT.GET_CONTRACTS(
        communityId,
        pageSizeCount,
        pageNumber,
        anonymize,
        search
    )
    );

export const useSearchBestuur = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_SEARCH_BESTUUR);

export const useUpdateAnonymize = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_UPDATE_ANONYMIZE);